<script setup lang="ts">
defineProps<{
  title: string
  image?: unknown
  badges: { label: string; accent?: boolean }[]
}>()
</script>

<template>
  <section class="pa-page-hero pa-vacancy-hero">
    <div class="pa-page-hero__background">
      <PrismicImage
        v-if="(image as any)?.url"
        :field="(image as any)"
        class="pa-page-hero__background-image"
      />
    </div>

    <div class="pa-page-hero__content">
      <div class="pa-container">
        <nav class="pa-page-hero__breadcrumbs">
          <NuxtLink to="/">Home</NuxtLink>
          <span class="pa-page-hero__breadcrumbs-separator">&ndash;</span>
          <NuxtLink to="/vacatures">Vacatures</NuxtLink>
          <span class="pa-page-hero__breadcrumbs-separator">&ndash;</span>
          <span class="pa-page-hero__breadcrumbs-current">{{ title }}</span>
        </nav>

        <h1 class="pa-page-hero__title">{{ title }}</h1>

        <div v-if="badges.length" class="pa-vacancy-hero__badges">
          <span
            v-for="(b, i) in badges"
            :key="i"
            class="pa-vacancy-hero__badge"
            :class="{ 'pa-vacancy-hero__badge--accent': b.accent }"
          >{{ b.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
